import React, { useEffect, useState } from "react";
import { fetchLeads } from "@/lib/adminApi";
import { PageHeader, StatCard } from "./_shared";
import LeadTable from "./LeadTable";
import LeadDrawer from "./LeadDrawer";

const ALL_TYPES = [
  "newsletter", "brochure", "calculator_report", "contact", "register",
  "sponsor", "exhibit", "speaker", "nomination", "market_report",
  "prospectus", "sponsorship_proposal",
];

export default function LeadsInboxPage() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(null);

  useEffect(() => {
    fetchLeads().then((d) => { setRows(d); setLoading(false); });
  }, []);

  const uncontacted = rows.filter(r => !r.extra?.contacted).length;
  const contacted = rows.filter(r => r.extra?.contacted).length;
  const unassigned = rows.filter(r => !r.extra?.assigned_to).length;

  return (
    <div data-testid="page-leads">
      <PageHeader
        title="All Leads · Inbox"
        subtitle="Every submission across the site — filter, assign, distribute to your team."
      />

      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
        <StatCard tone="navy" label="Total leads" value={rows.length} />
        <StatCard tone="lime" label="Contacted" value={contacted} />
        <StatCard tone="amber" label="Not contacted" value={uncontacted} />
        <StatCard tone="rose" label="Unassigned" value={unassigned} sub="Distribute now" />
      </div>

      {loading ? <div className="text-sm text-slate-500">Loading…</div> : (
        <LeadTable
          rows={rows}
          setRows={setRows}
          onRowClick={setActive}
          filename="bef2026-all-leads.csv"
          filterableTypes={ALL_TYPES}
          emptyText="No leads yet."
        />
      )}

      <LeadDrawer
        lead={active}
        onClose={() => setActive(null)}
        onChange={(u) => { setRows((prev) => prev.map((x) => x.id === u.id ? u : x)); setActive(u); }}
        onDelete={(id) => setRows((prev) => prev.filter((x) => x.id !== id))}
      />
    </div>
  );
}
